module.exports = __webpack_public_path__ + "img/chinesecompany203.d21c7b89.png";